import { render, staticRenderFns } from "./WorkOrderMessage.vue?vue&type=template&id=3c817722&scoped=true"
import script from "./WorkOrderMessage.vue?vue&type=script&lang=js"
export * from "./WorkOrderMessage.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderMessage.vue?vue&type=style&index=0&id=3c817722&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c817722",
  null
  
)

export default component.exports